import React, { useEffect } from "react";
import AdminPage from "../components/dashboards/adminpage";
import {
  AccountBalanceWallet,
  Redeem,
  People,
  ManageAccounts,
  PointOfSale,
  Person,
  // Work,
  MonetizationOn,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { DashboardStatus } from "../redux/slices/dashboard";
import RedeemIcon from "@mui/icons-material/Redeem";
import { ablyClient } from "../lib/socket";
import { UsersOnline } from "../redux/slices/activeUsers";
import { ApiSuccess } from "../redux/slices/active";
export function DashboardPage() {
  const dispatch = useDispatch();
  const datas = useSelector((value) => value.status.data);

  const login = useSelector((value) => value?.login?.user);
  // const user = useSelector((v) => v?.allcus?.data?.length);

  const active = useSelector((value) => value?.active?.active);

  const superadmin = {
    title: "Super Admin",
    data: [
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Free claim",
        value: `$${datas?.clims}`,
      },
      {
        icon: <People fontSize="large" color="primary" />,
        label: "Total Customers",
        value: datas?.customers?.users ? datas?.customers?.users : 0,
      },
      {
        icon: <ManageAccounts fontSize="large" color="secondary" />,
        label: "Total Agents",
        value: datas?.customers?.agents,
      },
      {
        icon: <Person fontSize="large" color="warning" />,
        label: "Managers",
        value: datas?.customers?.manager,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="success" />,
        label: "Overall Deposit",
        value: `$${datas?.deposits?.paid}/$${datas?.deposits?.unpaid}`,
      },
      {
        icon: <MonetizationOn fontSize="large" color="error" />,
        label: "Total Cashout",
        value: `$${datas?.cashout?.paid}`,
      },
      {
        icon: <RedeemIcon fontSize="large" color="info" />,
        label: "Total Redeem Request",
        value: `$${datas?.cashout?.unpaid}`,
      },
    ],
  };

  const admin = {
    title: "Admin",
    data: [
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Free claim",
        value: `$${datas?.clims}`,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Deposits in Wallet",
        value: `$${datas?.deposits?.paid}`,
      },
      {
        icon: <People fontSize="large" color="primary" />,
        label: "Total Customers",
        value: datas?.customers?.users,
      },
      {
        icon: <ManageAccounts fontSize="large" color="secondary" />,
        label: "Active Agents",
        value: active?.length,
      },
      {
        icon: <Person fontSize="large" color="warning" />,
        label: "Managers",
        value: datas?.customers?.manager,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="success" />,
        label: "Games Deposit",
        value: `$${datas?.game.deposit}`,
      },
      {
        icon: <Redeem fontSize="large" color="info" />,
        label: "Game Redeem",
        value: `$${datas?.game?.unpaid || 0}`,
      },
      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Wallet Cashout",
        value: `$${datas?.cashout?.paid}`,
      },
      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Pending Wallet Cashout",
        value: `$${datas?.cashout?.unpaid}`,
      },
      // {
      //   icon: <Work fontSize="large" color="warning" />,
      //   label: "Total Shift",
      //   value: "$0",
      // },
    ],
  };

  const manager = {
    title: "Manager",
    data: [
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Free claim",
        value: `$${datas?.clims}`,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Deposits in Wallet",
        value: `$${datas?.deposits?.paid}`,
      },
      {
        icon: <People fontSize="large" color="primary" />,
        label: "Total Customers",
        value: datas?.customers?.users,
      },
      {
        icon: <ManageAccounts fontSize="large" color="secondary" />,
        label: "Active Agents",
        value: active?.length,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="success" />,
        label: "Games Deposit",
        value: `$${datas?.game.deposit}`,
      },
      {
        icon: <Redeem fontSize="large" color="info" />,
        label: "Game Redeem",
        value: `$${datas?.game?.unpaid}`,
      },

      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Wallet Cashout",
        value: `$${datas?.cashout?.paid}`,
      },
      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Pending Wallet Cashout",
        value: `$${datas?.cashout?.unpaid}`,
      },
    ],
  };

  const depositagent = {
    title: "Deposit Agent",
    data: [
      {
        icon: <AccountBalanceWallet fontSize="large" color="success" />,
        label: "Deposit in Game",
        value: `$${datas?.game.deposit}`,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Deposit in Wallet",
        value: `$${datas?.deposits?.paid}`,
      },
      {
        icon: <Redeem fontSize="large" color="info" />,
        label: "Game Redeem",
        value: `$${datas?.cashout?.unpaid}`,
      },
      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Wallet Cashout",
        value: `$${datas?.cashout?.paid}`,
      },
      // {
      //   icon: <Work fontSize="large" color="warning" />,
      //   label: "Total Shift",
      //   value: "$0",
      // },
    ],
  };

  const redeemagent = {
    title: "Redeem Agent",
    data: [
      {
        icon: <AccountBalanceWallet fontSize="large" color="success" />,
        label: "Deposit in Game",
        value: `$${datas?.game.deposit}`,
      },
      {
        icon: <AccountBalanceWallet fontSize="large" color="primary" />,
        label: "Deposit in Wallet",
        value: `$${datas?.deposits?.paid}`,
      },
      {
        icon: <Redeem fontSize="large" color="info" />,
        label: "Game Redeem",
        value: `$${datas?.cashout?.unpaid}`,
      },
      {
        icon: <PointOfSale fontSize="large" color="secondary" />,
        label: "Wallet Cashout",
        value: `$${datas?.cashout?.paid}`,
      },
      // {
      //   icon: <Work fontSize="large" color="warning" />,
      //   label: "Total Shift",
      //   value: "$800",
      // },
    ],
  };

  const designer = {
    title: "Designer",
    data: [],
  };

  // create channel

  useEffect(() => {
    const channel = ablyClient.channels.get("presence-demo");

    const updateUserList = async () => {
      try {
        const members = await channel.presence.get();
        const current = members
          .map((m) => m?.data?.user?.name)
          .filter(
            (username) =>
              typeof username === "string" && username.trim() !== "",
          );

        dispatch(ApiSuccess(current));
      } catch (err) {
        console.error("Error fetching presence list:", err);
      }
    };

    channel.presence.subscribe(() => {
      updateUserList();
    });

    updateUserList();

    // return () => {
    //   channel.presence.leave();
    //   channel.presence.unsubscribe();
    // };
  }, []);

  useEffect(() => {
    const channel = ablyClient.channels.get("general-chat");

    const updatePresence = async () => {
      const presenceMembers = await channel.presence.get();

      const userMap = new Map();

      presenceMembers.forEach((member) => {
        const user = member?.data;
        if (user?.id) {
          userMap.set(user.id, user);
        }
      });

      const datas = Array.from(userMap.values());
      dispatch(UsersOnline(datas));
    };

    // channel.presence.subscribe("enter", updatePresence);
    // channel.presence.subscribe("leave", updatePresence);
    channel.presence.subscribe(() => {
      updatePresence();
    });
    return () => {
      channel.presence.unsubscribe();
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dispatch(DashboardStatus());
    }, 2000);
  }, [login]);

  //   Admin: "admin",
  // SuperAdmin: "super_admin",
  // Designer: "designer",
  // Manager: "manager",
  // Redeem_agent: "redeem_agent",
  // Deposit_agent: "deposit_agent",

  if (login?.role === "super_admin") {
    return <AdminPage data={superadmin?.data} title={superadmin?.title} />;
  } else if (login?.role === "admin") {
    return <AdminPage data={admin?.data} title={admin?.title} />;
  } else if (login?.role === "designer") {
    return <AdminPage data={designer?.data} title={designer?.title} />;
  } else if (login?.role === "manager") {
    return <AdminPage data={manager?.data} title={manager?.title} />;
  } else if (login?.role === "redeem_agent") {
    return <AdminPage data={redeemagent?.data} title={redeemagent?.title} />;
  } else if (login?.role === "deposit_agent") {
    return <AdminPage data={depositagent?.data} title={depositagent?.title} />;
  }
}
export default DashboardPage;
